import React, { memo } from 'react'

import Text from './Text'
import { Stack } from '@mui/material'

const PageHeading = ({ title, desc }) => {
  return (
    <Stack sx={{ mb: { xs: 3, md: 3 } }}>
      <Text label={title} variant='h4' />
      {desc && <Text variant='body2' label={desc} color='text.secondary' />}
    </Stack>
  )
}

export default memo(PageHeading)
